import { Config, Purchase } from "@cleeng/mediastore-sdk";
import axios from "axios";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Logout from "../../../components/Logout";
import { API_URL } from "../../../constants";
import { axiosConfig } from "../../../utils";

function CheckoutPage() {
  // const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const offerId = query.get("offerId");
  const handleSuccess = () => {
    window.history.go("/my-account");
  };
  const host = window.location.origin;

  useEffect(() => {
    Config.setMyAccountUrl(`${host}/my-account`); // required for legal notes
    Config.setCheckoutPayPalUrls({
      // PayPal redirection URLs, required for PayPal payment
      successUrl: `${host}/my-account`,
      cancelUrl: `${host}/choose-plan`,
      errorUrl: `${host}/choose-plan`,
    });
  }, [])

  const order = useSelector(state => state.order)
  // console.log({state});
  const getOffers = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/offers?status=active&pageLimit=3`,
        axiosConfig(),
      );

      const listPlans = (res && res.data && res.data.responseData) || [];
      return listPlans;
    } catch (error) {
    }
  };
  const isElementLoaded = async (selector, size = 1) => {
    while (document.querySelectorAll(selector).length < size) {
      await new Promise(resolve => requestAnimationFrame(resolve))
    }
    return document.querySelectorAll(selector);
  };

  const handleLoadImages = async () => {
    const plansPromise = getOffers();
    const titleElements = isElementLoaded('.msd__subscription-card__icon')
    const [plans, selectors] = await Promise.all([plansPromise, titleElements])

    for (let index = 0; index < selectors.length; index++) {
      const selector = selectors[index];
      const offer = plans.find(o => offerId.includes(o.id))
      if (offer) {
        selector.style = `background-image: url("${offer.imageUrl}");background-size: cover;color: transparent;`
      }
    }
  }
  useEffect(() => {
    if (offerId) {
      handleLoadImages()
    }
  }, [offerId, order])
  return (
    <>
      <Logout />
      <Purchase key={offerId} offerId={offerId} onSuccess={handleSuccess} />
    </>
  );
}

export default CheckoutPage;
